import Link from "next/link";
import { useRouter } from "next/router";
import { useState, useEffect } from "react";
import { clearCustomerData, customerCareNav } from "utils/helper";

import ButtonLink from "./button-link";
import CustomLink from "./custom-link";
import NextImage from "./image";
import NotificationBanner from "./notification-banner";

import styles from "@/styles/onboarding.module.scss";

const NavbarComp = ({
  navbar,
  notificationBanner,
  blank,
  application,
  customerCareHeader = false,
  isModified = false,
  showNav,
}) => {
  const [open, setOpen] = useState(false);

  const logoData = open
    ? navbar.logo.data2
    : isModified
      ? navbar.logo.data2
      : navbar.logo.data1;

  const router = useRouter();

  useEffect(() => {
    setOpen(false);
  }, [router.asPath]);

  const Header = props => {
    const [bannerIsShown, setBannerIsShown] = useState(true);
    return (
      <div className="w-full relative">
        {notificationBanner && bannerIsShown && (
          <NotificationBanner
            data={notificationBanner}
            closeSelf={() => setBannerIsShown(false)}
          />
        )}
        <nav
          className={`z-10 nav-section border-gray-900 ${
            open
              ? "bg-onmoPurple-100 absolute z-100 !text-onmoPrimary"
              : "absolute text-onmoSecondary"
          } ${application || blank ? "py-3 appNavLine" : "py-5"} w-full`}
        >
          {props.children}
        </nav>
      </div>
    );
  };

  if (blank) {
    return (
      <Header>
        <div className="py-1 px-6 mx-auto container-fluid flex flex-wrap justify-between items-center">
          <div className="flex flex-wrap justify-between items-center lg:gap-5 xl:gap-10">
            <Link href="/" legacyBehavior>
              <a className="flex items-center cursor-pointer">
                <NextImage priority media={logoData} width="150" height="37" />
              </a>
            </Link>
          </div>
        </div>
      </Header>
    );
  }

  if (customerCareHeader) {
    const onmouuid = router?.query?.onmouuid;
    return (
      <Header>
        <div className="px-5  mx-auto container-fluid flex flex-wrap justify-between items-center">
          <div className="flex flex-wrap justify-between items-center lg:gap-5 xl:gap-10">
            <Link href="/" legacyBehavior>
              <a className="flex items-center cursor-pointer">
                <NextImage priority media={logoData} width="150" height="37" />
              </a>
            </Link>
          </div>
          <button
            onClick={() => setOpen(!open)}
            data-collapse-toggle="mobile-menu"
            type="button"
            className="inline-flex items-center p-2 ml-3 text-sm text-gray-500 rounded-lg lg:hidden focus:outline-none"
            aria-controls="mobile-menu"
            aria-expanded="false"
          >
            <span className="sr-only">Open main menu</span>
            <svg
              className={`${open ? "hidden" : "block"} w-5 h-4"`}
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 11C0 10.4477 0.447715 10 1 10H15C15.5523 10 16 10.4477 16 11C16 11.5523 15.5523 12 15 12H1C0.447715 12 0 11.5523 0 11Z"
                fill="#D8D5FF"
              />
              <path
                d="M0 1C0 0.447715 0.447715 0 1 0H15C15.5523 0 16 0.447715 16 1C16 1.55228 15.5523 2 15 2H1C0.447715 2 0 1.55228 0 1Z"
                fill="#D8D5FF"
              />
            </svg>
            <svg
              className={`${open ? "block" : "hidden"} w-6 h-6"`}
              fill="#232323"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>
          <div
            className={
              open
                ? "w-full lg:block lg:w-auto py-5 sm:py-auto"
                : "hidden w-full lg:block lg:w-auto"
            }
            id="mobile-menu"
          >
            <ul className="flex flex-col gap-5 md:gap-10 lg:gap-5 xl:gap-10 mt-4 lg:flex-row lg:space-x-8 lg:mt-0 lg:text-base items-center">
              {customerCareNav.links.map(v => (
                <li
                  key={v.id}
                  className={`block py-2 px-2 ${styles.navLinks} ${
                    router.asPath === v.url ? "text-onmoPrimary" : ""
                  } ${isModified ? "text-onmoPrimary" : ""}`}
                >
                  <CustomLink link={v} onmouuid={onmouuid}>
                    {v.text}
                  </CustomLink>
                </li>
              ))}
              {customerCareNav.logOut && (
                <li
                  key={"3"}
                  className={`block py-2 px-2 ${styles.navLinks} ${
                    isModified ? "text-onmoPrimary" : ""
                  } `}
                >
                  <Link replace href="/" legacyBehavior>
                    <a
                      onClick={() => {
                        clearCustomerData();
                      }}
                    >
                      Logout
                    </a>
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
      </Header>
    );
  }

  const tick = (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 12.8L9.42857 16L18 8"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  if (application) {
    return (
      <Header>
        <div className="max-w-1424 py-1 px-5 lg:px-10 xl:px-20 mx-auto container-fluid flex flex-wrap justify-start md:justify-between items-center gap-5 md:gap-0">
          <div className="flex flex-wrap justify-between items-center lg:gap-5 xl:gap-10">
            <Link passHref href="/">
              <div className="flex items-center cursor-pointer">
                <NextImage priority media={logoData} width="150" height="37" />
              </div>
            </Link>
          </div>
          <div className="hidden md:block">
            <div className={styles.stepper_wrapper}>
              <div
                className={`${styles.stepper_item} ${
                  application >= 1 ? styles.stepper_item_active : null
                }`}
              >
                <div className={styles.step_counter}>
                  {application > 1 ? tick : 1}
                </div>
                <div className={styles.step_name}>Personal details</div>
              </div>
              <div
                className={`${styles.stepper_item} ${
                  application >= 2
                    ? application === 2.5
                      ? styles.stepper_item_error
                      : styles.stepper_item_active
                    : null
                }`}
              >
                <div className={styles.step_counter}>
                  {application > 2 ? (application === 2.5 ? 2 : tick) : 2}
                </div>
                <div className={styles.step_name}>Your offer</div>
              </div>
              <div
                className={`${styles.stepper_item} ${
                  application >= 3 ? styles.stepper_item_active : null
                }`}
              >
                <div className={styles.step_counter}>
                  {application > 3 ? tick : 3}
                </div>
                <div className={styles.step_name}>Get started</div>
              </div>
            </div>
          </div>
          <div className="w-[101px] hidden md:block" />
        </div>
      </Header>
    );
  }
  return (
    <>
      <Header>
        <div
          className={`px-6 mx-auto container-fluid flex flex-wrap justify-between items-center`}
        >
          <div className="flex flex-wrap justify-between items-center lg:gap-5 xl:gap-10">
            <Link passHref href="/">
              <div className=" items-center cursor-pointer hidden md:flex">
                <NextImage priority media={logoData} width="150" height="37" />
              </div>
              <div className=" items-center cursor-pointer flex md:hidden">
                <NextImage priority media={logoData} width="88" height="22" />
              </div>
            </Link>
          </div>
          {showNav && (
            <button
              onClick={() => setOpen(!open)}
              data-collapse-toggle="mobile-menu"
              type="button"
              className="inline-flex items-center p-2 ml-3 text-sm text-onmoSecondary rounded-lg lg:hidden focus:outline-none"
              aria-controls="mobile-menu"
              aria-expanded="false"
            >
              <span className="sr-only">Open main menu</span>
              <svg
                className={`${open ? "hidden" : "block"} w-5 h-4"`}
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 11C0 10.4477 0.447715 10 1 10H15C15.5523 10 16 10.4477 16 11C16 11.5523 15.5523 12 15 12H1C0.447715 12 0 11.5523 0 11Z"
                  fill={isModified ? "#5F27E0" : "#D8D5FF"}
                />
                <path
                  d="M0 1C0 0.447715 0.447715 0 1 0H15C15.5523 0 16 0.447715 16 1C16 1.55228 15.5523 2 15 2H1C0.447715 2 0 1.55228 0 1Z"
                  fill={isModified ? "#5F27E0" : "#D8D5FF"}
                />
              </svg>
              <svg
                className={`${open ? "block" : "hidden"} w-6 h-6"`}
                fill={open ? "#401999" : "#d8d5ff"}
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          )}
          {showNav && (
            <div
              className={
                open
                  ? "w-full lg:block lg:w-auto py-8 "
                  : "hidden w-full lg:block lg:w-auto"
              }
              id="mobile-menu"
            >
              <ul className="flex flex-col gap-5 md:gap-10 lg:gap-1 xl:gap-10 mt-4 lg:flex-row lg:space-x-4 lg:mt-0 lg:text-base items-center ">
                {navbar.links.map(v => (
                  <li
                    key={v.id}
                    className={`block py-2 px-2 ${styles.navLinks} ${
                      router.asPath === v.url
                        ? `${open ? "text-onmoPrimary" : "text-onmoSecondary"}`
                        : router.pathname.split("/")[1] === v.url.split("/")[1]
                          ? `${open ? "text-onmoPrimary" : "text-onmoSecondary"}`
                          : ""
                    } ${isModified ? "text-onmoPrimary" : ""}`}
                  >
                    <CustomLink link={v}>{v.text}</CustomLink>
                  </li>
                ))}
                {navbar.joinButton ? (
                  <ButtonLink
                    isBrandRefresh
                    button={{
                      text: "Join Onmo",
                      url: "/credit-card/application",
                      newTab: true,
                    }}
                    className={`py-3  pl-[16px] pr-[16px] !w-auto  rounded-3xl ${
                      open
                        ? "bg-onmoPrimary text-onmoSecondary"
                        : isModified
                          ? "bg-onmoPrimary !text-onmoSecondary"
                          : "bg-onmoSecondary text-onmoPrimary"
                    }  cursor-pointer `}
                  />
                ) : null}
              </ul>
            </div>
          )}
        </div>
      </Header>
    </>
  );
};

export default NavbarComp;
